import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import HeadingSmall from "./HeadingSmall";
import IndentedParagraphSmall from "./IndentedParagraphSmall";
import NewsletterSignup from "./NewsletterSignup";
import React from "react";
import PropTypes from "prop-types";

function Signup({ heading, text, buttonText, brand }) {
  return (
    <BoxWithGutter>
      <Box
        maxWidth={760}
        mx="auto"
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <HeadingSmall uppercase>{heading}</HeadingSmall>
        <Box my={[38, null, 50, null]}>
          <IndentedParagraphSmall>{text}</IndentedParagraphSmall>
        </Box>
        <NewsletterSignup brand={brand} buttonText={buttonText} />
      </Box>
    </BoxWithGutter>
  );
}

Signup.propTypes = {
  heading: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  brand: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
};

export default Signup;
